import { createAction, props } from '@ngrx/store';

const GET_DATA = '[Languages] Get Data';
const SET_LANGUAGES = '[Languages] set Languages';
const SAVE_LANGUAGES = '[Languages] Save Languages';
const GET_TRANSLATIONS = '[Translations] Get Translations';
const SET_TRANSLATIONS = '[Translations] Set Translations';
const UPDATE_TRANSLATIONS = '[Translations] Update Translations';

const getData = createAction(GET_DATA, props<{ apiConstants: any }>());

const saveLanguages = createAction(SAVE_LANGUAGES, props<{ saveApiConstants: any; languagesData: any }>());

const setLanguages = createAction(SET_LANGUAGES, props<{ languagesRes: any }>());

const getGeneratedTranslations = createAction(GET_TRANSLATIONS, props<{ apiConstants: any }>());

const setTranslations = createAction(SET_TRANSLATIONS, props<{ translationsData: any }>());

const updateTranslations = createAction(UPDATE_TRANSLATIONS, props<{ saveApiConstants: any; translationsData: any }>());

export { getGeneratedTranslations, setTranslations, updateTranslations, getData, saveLanguages, setLanguages };
